import { STATUS_FAIL } from '@/mixins/onlineCheckMixin';

/**
 * @description Списание аванса.
 * @param {number} cashboxId Идентификатор кассы.
 * @param {number} rubles    Количество рублей.
 * @param {string} mode      Способ списания.
 * @constructor
 */
export function AdvanceWithdrawal(cashboxId, rubles, mode) {
  this.cashboxId = cashboxId;
  this.rubles = rubles;
  this.mode = mode;
}

/**
 * @description Примесь списания аванса.
 * @type {object}
 */
export default {
  data() {
    return {
      /**
       * @description Аванс для списания.
       * @type {(object|null)}
       */
      advanceForWithdrawal: null,
      /**
       * @description Ожидание завершения запроса списания аванса.
       * @type {boolean}
       */
      isAwaitAdvanceWithdrawalRequest: false,
      /**
       * @description Список касс для списания.
       * @type {any[]}
       */
      cashboxListForWithdrawal: [],
    };
  },
  methods: {
    /**
     * @description Ожидание распечатки чека.
     * @type {number} commandId Идентификатор команды.
     * @returns {Promise<boolean>}
     */
    waitAdvanceWithdrawalCheckPrinted(commandId) {
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
        return false;
      };
      const onSuccess = (result) => {
        if (result.status === STATUS_FAIL) {
          this.notifyFail(result.message);
          return false;
        }
        this.onCloseAdvanceWithdrawalForm();
        this.notifySuccess('Чек получен');
        return true;
      };
      return this
        .waitExecuted(commandId)
        .then(onSuccess, onFail)
        .finally(() => {
          this.isAwaitCommandExecuted = false;
        });
    },
    /**
     * @description Открыть форму.
     * @returns {void}
     */
    openAdvanceWithdrawalForm() {
      this
        .$invoiceGateway
        .viewPatientAdvanceForWithdrawal(this.patientId)
        .then((result) => {
          result.forEachLeft(({ title }) => { this.notifyFail(title); });
          result.forEach(({ data }) => {
            this.cashboxListForWithdrawal = data;
            this.advanceForWithdrawal = true;
          });
        });
    },
    /**
     * @description Обработать закрытие формы.
     * @returns {void}
     */
    onCloseAdvanceWithdrawalForm() {
      this.advanceForWithdrawal = null;
    },
    /**
     * @description Обработать отправку списания с аванса.
     * @param {number}            patientId  Идентификатор пациента.
     * @param {AdvanceWithdrawal} withdrawal Списание.
     * @returns {Promise<boolean>}
     */
    sendAdvanceWithdrawalRequest(patientId, withdrawal) {
      this.isAwaitAdvanceWithdrawalRequest = true;
      const onFail = (error) => {
        this.notifyFail(error.title);
        return false;
      };
      const onSuccess = (response) => {
        this.notifySuccess(response.message);
        if (response.command_id) {
          return this.waitAdvanceWithdrawalCheckPrinted(response.command_id);
        }
        this.onCloseAdvanceWithdrawalForm();
        return true;
      };
      return this
        .$invoiceGateway
        .withdrawPatientAdvance(patientId, withdrawal)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => { this.isAwaitAdvanceWithdrawalRequest = false; });
    },
  },
};
